module.exports = __webpack_public_path__ + "static/media/21 Sprawl.d3ee7f86.jpg";